export default __webpack_public_path__ + "static/media/4062.3cdf0dd7.png";